import { CompetitionLevel, CompetitionStatus, CompetitionType } from '@shared/enums/domain.enum';

export const PAGE_SIZE = 10;

export const VALID_SORT_BY = ['date', 'name', 'price', 'currentTeams'] as const;
export type SortBy = (typeof VALID_SORT_BY)[number];

export function parseSortBy(value: string | null): SortBy {
  return VALID_SORT_BY.includes(value as SortBy) ? (value as SortBy) : 'date';
}

export function parsePage(value: string | null): number {
  const n = Number(value);
  return Number.isInteger(n) && n >= 1 ? n : 1;
}

export function parseRadius(value: string | null): number {
  const n = Number(value);
  return Number.isInteger(n) && n > 0 ? n : 50;
}

export function parseType(value: string | null): CompetitionType | '' {
  return Object.values(CompetitionType).includes(value as CompetitionType) ? (value as CompetitionType) : '';
}

export function parseLevel(value: string | null): CompetitionLevel | '' {
  return Object.values(CompetitionLevel).includes(value as CompetitionLevel) ? (value as CompetitionLevel) : '';
}

export function parseStatus(value: string | null): CompetitionStatus | '' {
  return Object.values(CompetitionStatus).includes(value as CompetitionStatus) ? (value as CompetitionStatus) : '';
}

// Feature 5 (2026-08) — sentinelle « tous les statuts ». Le défaut (param absent)
// est REGISTRATION_OPEN ; l'utilisateur choisit explicitement « Tous » (= ALL)
// pour lever le filtre de statut.
export const ALL_STATUSES = 'ALL';

export function parseStatusWithDefault(value: string | null): CompetitionStatus | '' {
  if (value === null) return CompetitionStatus.REGISTRATION_OPEN;
  if (value === ALL_STATUSES) return '';
  return parseStatus(value);
}

// Feature 6 (2026-08) — filtre par organisateur (organizationId). Le param URL
// `organizer` porte l'id de l'organisation.
export function parseOrganizer(value: string | null): number | undefined {
  const n = Number(value);
  return Number.isInteger(n) && n > 0 ? n : undefined;
}

export const RESTRICTION_VALUES = ['all', 'open', 'licensed', 'affiliated', 'both'] as const;
export type RestrictionFilter = (typeof RESTRICTION_VALUES)[number];

export function parseRestriction(value: string | null): RestrictionFilter {
  return RESTRICTION_VALUES.includes(value as RestrictionFilter) ? (value as RestrictionFilter) : 'all';
}
